import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Redirects to the site root (/) via full page load so the server serves
 * the static marketing site. Used when the user navigates to / from within
 * the React app (e.g. clicking the logo). See dev-plans/37-post-launch-v1.0.1/sprint-02/03-react-root-route.md
 *
 * On the Vite dev server (:5173) the static marketing site doesn't exist —
 * doing window.location.href = '/' would reload the SPA and hit this route
 * again, causing an infinite loop. In that case, navigate to /login instead.
 */
const NavigateToMarketingRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isViteDevServer = import.meta.env.DEV || import.meta.env.MODE === 'development';
    if (isViteDevServer) {
      // No marketing site on the Vite dev server — go to login
      navigate('/login', { replace: true });
    } else {
      // Full page load to serve the static marketing site from the backend
      window.location.href = '/';
    }
  }, [navigate]);

  return null;
};

export default NavigateToMarketingRoot;
